var Assam = "أسام";
var Bihar = "بيهار";
var Chandigarh = "شانديغار";
var Chhattisgarh = "تشهاتيسجاره";
var Delhi = "دلهي";
var Goa = "غوا";
var Gujarat = "غوجارات";
var Haryana = "هاريانا";
var Jharkhand = "جهارخاند";
var Karnataka = "كارناتاكا";
var Kerala = "كيرلا";
var Lakshwadeep = "لاكشواديب";
var Maharashtra = "ماهاراشترا";
var Manipur = "مانيبور";
var Meghalaya = "ميغالايا";
var Mizoram = "ميزورام";
var Nagaland = "ناجالاند";
var Orrisa = "أوريسا";
var Puducherry = "بودوتشيري";
var Punjab = "البنجاب";
var Rajasthan = "راجستان";
var Sikkim = "سيكيم";
var Telangana = "تيلانجانا";
var Tripura = "تريبورا";
var Uttrakhand = "أوتراخاند";
var INStates = {
	"Andaman and Nicobar Islands": "جزر أندامان ونيكوبار",
	"Andhra Pradesh": "أندرا براديش",
	"Arunachal Pradesh": "أروناتشال براديش",
	Assam: Assam,
	Bihar: Bihar,
	Chandigarh: Chandigarh,
	Chhattisgarh: Chhattisgarh,
	"Dadra & Nagar Haveli": "دادرا وناجار هافيلي",
	"Daman & Diu": "دامان آند ديو",
	Delhi: Delhi,
	Goa: Goa,
	Gujarat: Gujarat,
	Haryana: Haryana,
	"Himachal Pradesh": "هيماشال براديش",
	"Jammu and Kashmir": "جامو وكشمير",
	Jharkhand: Jharkhand,
	Karnataka: Karnataka,
	Kerala: Kerala,
	Lakshwadeep: Lakshwadeep,
	"Madhya Pradesh": "ماديا براديش",
	Maharashtra: Maharashtra,
	Manipur: Manipur,
	Meghalaya: Meghalaya,
	Mizoram: Mizoram,
	Nagaland: Nagaland,
	Orrisa: Orrisa,
	Puducherry: Puducherry,
	Punjab: Punjab,
	Rajasthan: Rajasthan,
	Sikkim: Sikkim,
	"Tamil Nadu": "تاميل نادو",
	Telangana: Telangana,
	Tripura: Tripura,
	"Uttar Pradesh": "أوتار براديش",
	Uttrakhand: Uttrakhand,
	"West Bengal": "بنغال الغربية"
};

export { Assam, Bihar, Chandigarh, Chhattisgarh, Delhi, Goa, Gujarat, Haryana, Jharkhand, Karnataka, Kerala, Lakshwadeep, Maharashtra, Manipur, Meghalaya, Mizoram, Nagaland, Orrisa, Puducherry, Punjab, Rajasthan, Sikkim, Telangana, Tripura, Uttrakhand, INStates as default };
